import React from "react";
import ReactPlayer from "react-player";

const VideoPlayer = () => {
  return (
    <ReactPlayer
      className="player"
      url="https://www.youtube.com/watch?v=7DuKSdp63ko"
      width="100%"
      height="100%"
      volume={0.3}
      controls
    />
  );
};

export default VideoPlayer;
